// extracted by mini-css-extract-plugin
export default {"container":"styles_container__T57wG","image":"styles_image__0dOqz"};